module.exports = __webpack_public_path__ + "static/bellavita-17d2160ccad1bcaaa82f5b1eff7d1710.png";